import React, { useState, useEffect } from "react";
import { useNavigate, useOutletContext } from "react-router-dom";
import useAxiosPrivate from "../hooks/useAxiosPrivate";
import { format } from "date-fns";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Dropdown } from "primereact/dropdown";
import { Button } from "primereact/button";
import { Card } from "primereact/card";
import { Toolbar } from "primereact/toolbar";
import { InputText } from "primereact/inputtext";
import { exportExcel } from "../hooks/useExportUtils";
import NominaContext from "../context/NominProvider";

export const ListadoEmpleados = () => {
   //const { selectedNomina } = useOutletContext();
     const { selectedNomina } = React.useContext(NominaContext);


   const { selectedNominaId } = useOutletContext();
console.log("ListadoEmpleados - selectedNominaId:", selectedNominaId);

     const [nominas, setNominas] = React.useState([]);

       //const selectedNomina = nominas.find(x => x.idNomina === selectedNominaId) || null;
     

  const [empleados, setEmpleados] = useState([]);
  const [first2, setFirst2] = useState(0);
  const [rows2, setRows2] = useState(50);
    const [globalFilter, setGlobalFilter] = useState("");
  
  const axiosPrivate = useAxiosPrivate();
  const navigate = useNavigate();

  const getData = async () => {
    try {
      console.log("Obteniendo empleados para la getData:", selectedNomina.idNomina);
      const response = await axiosPrivate.get("NOM/empleados/listado/" + selectedNomina.idNomina);
        
      const data = response.data;
      setEmpleados(data);
    } catch (error) {
      console.error("Error al obtener empleados:", error);
    }
  };

//   useEffect(() => {
//   if (!selectedNomina) return;
//   getData();
// }, [selectedNomina]);

useEffect(() => {
  //if (!selectedNomina) return;
  console.log("selectedNomina cambiado:", selectedNomina);  
  getData();
}, []);

// useEffect(() => {
//   if (selectedNomina?.idNomina) {
//     axiosPrivate.get("NOM/empleados/listado/" + selectedNomina.idNomina)
//       .then((response) => {
//         console.log("Empleados response:", response.data);
//         setFaltas(response.data);
//       })
//       .catch((error) => {
//         console.error("Error al obtener empleados:", error);
//       });
//   }
// }, [selectedNomina?.idNomina]);

  const columns = [
    { field: "numero", header: "Número" , sortable: true},
    { field: "Nombre", header: "Nombre", sortable: true },
    { field: "Estatus", header: "Estatus" , sortable: true},
    { field: "Nomina", header: "Nomina", sortable: false },
    { field: "RFC", header: "RFC" , sortable: true},
    { field: "CorreoElectronico", header: "Email", sortable: true },
    { field: "Practica", header: "Practica" , sortable: true},
    { field: "Puesto", header: "Puesto" , sortable: true},
    { field: "Region", header: "Region", sortable: false },
    { field: "Socio", header: "Socio" , sortable: true, filter: false},
  ];

  const dynamicColumns = columns.map((col) => (
    <Column key={col.field} field={col.field} header={col.header} sortable={col.sortable} filter={col.filter} />
  ));

  const template2 = {
    layout: "RowsPerPageDropdown CurrentPageReport PrevPageLink NextPageLink",
    RowsPerPageDropdown: (options) => {
      const dropdownOptions = [
        { label: 10, value: 10 },
        { label: 20, value: 20 },
        { label: 50, value: 50 },
      ];

      return (
        <>
          <span className="mx-2">Items por página:</span>
          <Dropdown value={options.value} options={dropdownOptions} onChange={options.onChange} />
        </>
      );
    },
    CurrentPageReport: (options) => (
      <span className="mx-2">
        {options.first} - {options.last} de {options.totalRecords}
      </span>
    )
  };

  const onCustomPage2 = (event) => {
    setFirst2(event.first);
    setRows2(event.rows);
  };
 const handleBack = () => {
    navigate(-1);
  };
 const leftToolbarTemplate = () => (
    <div className="flex gap-2 items-center flex-center">
      {/* <label htmlFor="periodo" className="whitespace-nowrap">Filtrar por periodo:</label>
      <Dropdown
        id="periodo"
        // value={periodoSeleccionado}
        // options={periodosDisponibles}
        // onChange={(e) => setPeriodoSeleccionado(e.value)}
        placeholder="Selecciona periodo"
        className="w-15rem"
        showClear
      /> */}
      <Button
        label="Exportar Excel"
        icon="pi pi-file-excel"
        severity="success"
        onClick={() => exportExcel(empleados, "Faltas")}
      />
    </div>
  );

  const rightToolbarTemplate = () => (
    <span className="p-input-icon-left">
      <i className="pi pi-search" />
      <InputText
        type="search"
        placeholder="Buscar..."
        value={globalFilter}
        onChange={(e) => setGlobalFilter(e.target.value)}
        className=" ml-4"
      />
    </span>
  );


  return (
    <div className="p-m-4">
      <Card title="Empleados">
        <div className="mb-3 flex justify-content-between">
                    <Button
                      label="Regresar"
                      icon="pi pi-arrow-left"
                      className="p-button-secondary"
                      onClick={handleBack}
                    />
                  </div>
<Toolbar
          className="mb-4"
          left={leftToolbarTemplate}
          right={rightToolbarTemplate}
        />                  
        <DataTable
          value={empleados}
          responsiveLayout="scroll"
          paginator
          paginatorTemplate={template2}
          first={first2}
          rows={rows2}
          onPage={onCustomPage2}
          removableSort
          globalFilter={globalFilter} 
          // header={rightToolbarTemplate()}
          className="p-datatable-sm"
          stripedRows
        >         
          {dynamicColumns} 
          
        </DataTable>
      </Card>
    </div>
  );
};

export default ListadoEmpleados;
